
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqr1_45MsokNxxds1L3PtoN_TzPEwPq4VQIk_S7I5tzEULIMeta } from "/codebuild/output/src3511244156/src/src/pages/faq.vue?macro=true";
import { default as menut0P7cgLk8XCMacbW_GwY_45BR88xUR1JH_45HCIr46D8cYcMeta } from "/codebuild/output/src3511244156/src/src/pages/menu.vue?macro=true";
import { default as indexUMoRCMTznP_M1Q3xHgkKtknyOTFlmP2dcgmtBnJj_45g0Meta } from "/codebuild/output/src3511244156/src/src/pages/index.vue?macro=true";
import { default as contact6Urof_kEGqoLjv7LIGmMHMjw_45dhdhHt7h8jR7sjgAvYMeta } from "/codebuild/output/src3511244156/src/src/pages/contact.vue?macro=true";
import { default as tutorialmi7RIu9hLv7BU6YmsruQnaJI4mG_45xhg5u2k5zIeqB_oMeta } from "/codebuild/output/src3511244156/src/src/pages/tutorial.vue?macro=true";
import { default as agreementImiNXr_IS_45oZSJTUy_45ggMAvOId2lCAl6J0KlLUHMeKAMeta } from "/codebuild/output/src3511244156/src/src/pages/agreement.vue?macro=true";
import { default as about_45pass6QSOiJtoG_45zMt6TaqYEoLdCqGzxnAjdRFwygBGyVpNsMeta } from "/codebuild/output/src3511244156/src/src/pages/about-pass.vue?macro=true";
import { default as indexs9mco6sQpGFi9LcriQjh_450W2TlgksAKyjuodcSjd82wMeta } from "/codebuild/output/src3511244156/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93lR3RY_pFJ0X6m5DiyfNxaSb_VwkSA6msEf1TInRCRYQMeta } from "/codebuild/output/src3511244156/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceQIB9i8xqqKA8cPDErRS6twZmDhDcso_45soUDJcoBSNVYMeta } from "/codebuild/output/src3511244156/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93f2fQ2ybBxmV6Xk_Lrb8C5ZwlGLaMi_45p39EnqokTb_R0Meta } from "/codebuild/output/src3511244156/src/src/pages/notice/[id].vue?macro=true";
import { default as indexKeSiQE7uYDC_vgZiQw9lDrkvURqh_JgIDcf4SFSwqZIMeta } from "/codebuild/output/src3511244156/src/src/pages/coupon/index.vue?macro=true";
import { default as indexrz2LviBtFEKj_Y6n277fjrYnn6jLOqiqC8P_ZLlbGEMMeta } from "/codebuild/output/src3511244156/src/src/pages/mypage/index.vue?macro=true";
import { default as indexg8K68puDoZArH2jVop8amUYuLzueL9tnaBHpi6bxmwUMeta } from "/codebuild/output/src3511244156/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_932_45w2U96IjKKLL9ci7Js4bou8m11c4A5Ku2WEkBtK5WkMeta } from "/codebuild/output/src3511244156/src/src/pages/parking/[id].vue?macro=true";
import { default as indexILYaahfenTZZExvVCpSWQ3JkFdGxI5PsfbyDMOZRX2UMeta } from "/codebuild/output/src3511244156/src/src/pages/history/index.vue?macro=true";
import { default as indexDP5OHH3CjlEqHe86GthWRbHU5r_45KNOAj5EwMRKxfjdUMeta } from "/codebuild/output/src3511244156/src/src/pages/monthly/index.vue?macro=true";
import { default as indexNsP6lFv6jPBh6b_4tb6fUtgUxQWg5ZjJFgg_45oHPO6DsMeta } from "/codebuild/output/src3511244156/src/src/pages/sign-in/index.vue?macro=true";
import { default as index0n7aBKDGZIK6OLmIm_l6BkioMsx6_Gejmv0ziXguKDcMeta } from "/codebuild/output/src3511244156/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavibyrsKUzMom3FHSCE_45628k6JNKipVkYJxck3GeuvAujAMeta } from "/codebuild/output/src3511244156/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editeQPeyhXhsb6YxfXp8snomb3LwnQa6SF3ILAEtk413QoMeta } from "/codebuild/output/src3511244156/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementkXvq4nRUB_zhrJP88ZE4Sk6HfFkUofiOJXyYVKVHi1cMeta } from "/codebuild/output/src3511244156/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexHt2v87553BEwbYgJ4tulxYtoj_45pb1ytky2_45nfQ7UrAIMeta } from "/codebuild/output/src3511244156/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453ddbfWsRkZSnsHQwsjdYAo8eqR_45e72_33pcxG3bbTH10oMeta } from "/codebuild/output/src3511244156/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmustwXoXoD2Hud7wa6k7dfVUrF69f6GV6GOLnSX_9iSAMeta } from "/codebuild/output/src3511244156/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexhkrtjSE1JY0bvstytRMxXeSHTc35b_45CxuYeJa_45fHcD0Meta } from "/codebuild/output/src3511244156/src/src/pages/card/create/index.vue?macro=true";
import { default as indexhEaBQNdWlJKpjxML5GC2S4_BvccDLkhnAtsHxdhqRusMeta } from "/codebuild/output/src3511244156/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmIkIHpuJH5ZmMSXoWcpeKpXscjlAAddQO9brrVnfkxgsMeta } from "/codebuild/output/src3511244156/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmV9ktq5kl4Hrjk9B0JRgI3D79NcRlLK0msG1m5OVU_4540Meta } from "/codebuild/output/src3511244156/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeku0IF_45_45xkv7awA_45L3uAcx_45CLKfFBXwlYMYsKnYOGSX0Meta } from "/codebuild/output/src3511244156/src/src/pages/membership/complete.vue?macro=true";
import { default as registerGc4lxfKEiUWeXqyIMoldhLI5A2JMtOexdgvIe0ncF5MMeta } from "/codebuild/output/src3511244156/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93_LuzS_4526ZIA_kWLpS5h5NKoVTXlcmO_NdyLUCsydQAkMeta } from "/codebuild/output/src3511244156/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmXVlT1O3sqUa7pXc1OQf0QsU4YubWPDWqWp6hQZP0DVoMeta } from "/codebuild/output/src3511244156/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93z1Vg36t8jNYBNg5LpmiqXtz8nBUt_45Pik4EwYI2tRbT0Meta } from "/codebuild/output/src3511244156/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexHrlfNSnQzFv46PRnmPk2dbRgPc63yfm31TcbzcZOPLIMeta } from "/codebuild/output/src3511244156/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeelLYsyj6Khy6oKaGxacQ3fR_45STxFBW4yxmrQp98W6scMeta } from "/codebuild/output/src3511244156/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codesP8j38o91uhgcFsUo_VnYVanUk0k8ll0eyc3p_454G_b4Meta } from "/codebuild/output/src3511244156/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeDDEqWJYN5X8GWs8pMU4Gq8cS9mjUt21JC1O120k5uu8Meta } from "/codebuild/output/src3511244156/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerfUNJekvkON0C8v6eLDTOs980xmKLPETQp48T8F85TswMeta } from "/codebuild/output/src3511244156/src/src/pages/contact-form/register.vue?macro=true";
import { default as completedYLdGL67UaeP2V86ux4Cj5G1rGKSBNsTwLKwnzKGOo4Meta } from "/codebuild/output/src3511244156/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexMU818_45adErJQgTbRAsbvYmeDkzHuyJgMY2JVVXsBg_EMeta } from "/codebuild/output/src3511244156/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmaqpNASInjra1q0Ce6d_e4i1fkLn_45nYR_uNomcPuYnhAMeta } from "/codebuild/output/src3511244156/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeyxQmLBTzu5ChnUZ051RifWhMT4WuFCZrevlz2OD_x3UMeta } from "/codebuild/output/src3511244156/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexBLnss_DuIfBu4dKlJ4bDNBI9kcK90nBY9pnIdJAAlNYMeta } from "/codebuild/output/src3511244156/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_931vBMDZGGagEHSrHzW17lvPVzyk1xpfeDKfdrR_45mzw48Meta } from "/codebuild/output/src3511244156/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeLqTTDYMqBlK3GUIaJ1018rS7Th7mJcszEBR9qMU3ODQMeta } from "/codebuild/output/src3511244156/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45alias4oiUGwC_bCt97V_45haPX5JxUk61qEZBjZ0FqgJ88vKskMeta } from "/codebuild/output/src3511244156/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleSWSNWWRR9omaZjChALQxfLXnKwdZSTKO08W2FD_fRVAMeta } from "/codebuild/output/src3511244156/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailLw1uu3C6kGSFqOVm4Eb5DeohSj5G6iR_9Ub1IpoDSV0Meta } from "/codebuild/output/src3511244156/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmDoWjdpR92_45ZzPWRcA29ZYkFRdVrzztd_94BnT001mw4Meta } from "/codebuild/output/src3511244156/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentd_aZWtKUulu56LVSB9MQxJ0cFZ80D1iWQLKHDNDE8O4Meta } from "/codebuild/output/src3511244156/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmAMO3_45m9c6CJvTKZoLT0H7chSwmtEWYYyo5_45twvtEA_UMeta } from "/codebuild/output/src3511244156/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateyXO6lXs5I8Rp_455BSNVykpq0xAhckmBhYs3S22bv11NsMeta } from "/codebuild/output/src3511244156/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeK_45yBlTgfQGxspT0LjgirdWJTH5YdGFAxTjV8jtNSOa0Meta } from "/codebuild/output/src3511244156/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codepYNGOxX4oxBS5OE0Eyg9W3zKH2rTBijaEUOMJZJ2qhoMeta } from "/codebuild/output/src3511244156/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordUCx29S5RmDyGxFjNb4gSsYfY8y9uOJCP4P3epB3BTCIMeta } from "/codebuild/output/src3511244156/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliaso6kMUnHYhdeyxwWxgERzwiO81juOZPKx7HlnkHnOOnwMeta } from "/codebuild/output/src3511244156/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register8kxN0Rg_XTy2SYHkWutsEyydOYkss7Ru4uqrS8eEJO4Meta } from "/codebuild/output/src3511244156/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeNWqLGjO_dKdF_6gbJtzwUuLRLHsGWKf4S_45CdODVIloIMeta } from "/codebuild/output/src3511244156/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as index6EcbaHdYHZpFa_45iebQ_45yi8m5iHQDXHx0WkCxV8CMDLkMeta } from "/codebuild/output/src3511244156/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexS4e20yxAEGNKzJwWUkgk_45ymheZGa153EOYlW7lIj1lsMeta } from "/codebuild/output/src3511244156/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexIh1m7ilKUtcN4dQ60MDU_6yTHfzXdLrfQKf8Es75ncgMeta } from "/codebuild/output/src3511244156/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexyeqJXcZ5dV6umjbGbo9ch9LHsqLb2bsPb86D4S7T3awMeta } from "/codebuild/output/src3511244156/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateGqakzbZhKqVvoypYorghaZ3dz9Ox4DhKHo8hZ3sULW0Meta } from "/codebuild/output/src3511244156/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeXmBVan9n_45vo06hm2N6069_45lBk4GRQ1HCoNWoyki3o_0Meta } from "/codebuild/output/src3511244156/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmcAcjYDRjO7h1kyS3BPMQAvM6vaVAHQHKIwxFNO_454Gw8Meta } from "/codebuild/output/src3511244156/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexU4j7gC9dhmuac5vsIyQON9HyxJ_45oEqlMpxuo_45GX6DxIMeta } from "/codebuild/output/src3511244156/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeMIYyrKzD48darZcJ1yIX59a8kOivnVLipxp0PBLRiV4Meta } from "/codebuild/output/src3511244156/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateTQPjgOr5lqdrLDjZDshfWQ4U7zYQ6asrUd92uK1xteIMeta } from "/codebuild/output/src3511244156/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexGEYvzQogDwpOEzIfaEojR1fWzAeSyODrqdU9b9sd7goMeta } from "/codebuild/output/src3511244156/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexVL1tUT6vQ_45mK8V_wbxeoIzhQuT851HIK99Grwoc6s6AMeta } from "/codebuild/output/src3511244156/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as complete6TZ1_45yx4rBoWH4hqq5zL8zbAysmRMROkCnFGMvpbR5oMeta } from "/codebuild/output/src3511244156/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as index4dBWz053iIkz77uWxIFCuNYLvdoeYES1CK3OecjO8hkMeta } from "/codebuild/output/src3511244156/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codew9JcmrxThoDOWZuhpYuLbdjarNYWs284vku2Xxy9u_45sMeta } from "/codebuild/output/src3511244156/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexrz1kWZ5uaRMgV0l9rhEoaU91kHkk_VOoIPCO1xOIszUMeta } from "/codebuild/output/src3511244156/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexcu1Wu3Hx0lajNWT_CAv3HyQ0MZnwsAceG3pjJEeFJNQMeta } from "/codebuild/output/src3511244156/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as index_3_456_OVnJh1i0M7EUKJErT_45a7N__F8cmekWMJKxu_KoMeta } from "/codebuild/output/src3511244156/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateViMluG26v59QMoHGFDeI0SxBqYlnGwcySFaD_nryYSAMeta } from "/codebuild/output/src3511244156/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmNnyu7yd1PjZ_RQ8SC6CC2e9EEBA0JfszGWmNv7neouYMeta } from "/codebuild/output/src3511244156/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menut0P7cgLk8XCMacbW_GwY_45BR88xUR1JH_45HCIr46D8cYcMeta || {},
    component: () => import("/codebuild/output/src3511244156/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexUMoRCMTznP_M1Q3xHgkKtknyOTFlmP2dcgmtBnJj_45g0Meta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src3511244156/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexKeSiQE7uYDC_vgZiQw9lDrkvURqh_JgIDcf4SFSwqZIMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src3511244156/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src3511244156/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src3511244156/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src3511244156/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexILYaahfenTZZExvVCpSWQ3JkFdGxI5PsfbyDMOZRX2UMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src3511244156/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexNsP6lFv6jPBh6b_4tb6fUtgUxQWg5ZjJFgg_45oHPO6DsMeta || {},
    component: () => import("/codebuild/output/src3511244156/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: index0n7aBKDGZIK6OLmIm_l6BkioMsx6_Gejmv0ziXguKDcMeta || {},
    component: () => import("/codebuild/output/src3511244156/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3511244156/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3511244156/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexhkrtjSE1JY0bvstytRMxXeSHTc35b_45CxuYeJa_45fHcD0Meta || {},
    component: () => import("/codebuild/output/src3511244156/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src3511244156/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmIkIHpuJH5ZmMSXoWcpeKpXscjlAAddQO9brrVnfkxgsMeta || {},
    component: () => import("/codebuild/output/src3511244156/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmV9ktq5kl4Hrjk9B0JRgI3D79NcRlLK0msG1m5OVU_4540Meta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src3511244156/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeku0IF_45_45xkv7awA_45L3uAcx_45CLKfFBXwlYMYsKnYOGSX0Meta || {},
    component: () => import("/codebuild/output/src3511244156/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerGc4lxfKEiUWeXqyIMoldhLI5A2JMtOexdgvIe0ncF5MMeta || {},
    component: () => import("/codebuild/output/src3511244156/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmXVlT1O3sqUa7pXc1OQf0QsU4YubWPDWqWp6hQZP0DVoMeta || {},
    component: () => import("/codebuild/output/src3511244156/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeelLYsyj6Khy6oKaGxacQ3fR_45STxFBW4yxmrQp98W6scMeta || {},
    component: () => import("/codebuild/output/src3511244156/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codesP8j38o91uhgcFsUo_VnYVanUk0k8ll0eyc3p_454G_b4Meta || {},
    component: () => import("/codebuild/output/src3511244156/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeDDEqWJYN5X8GWs8pMU4Gq8cS9mjUt21JC1O120k5uu8Meta || {},
    component: () => import("/codebuild/output/src3511244156/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerfUNJekvkON0C8v6eLDTOs980xmKLPETQp48T8F85TswMeta || {},
    component: () => import("/codebuild/output/src3511244156/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmaqpNASInjra1q0Ce6d_e4i1fkLn_45nYR_uNomcPuYnhAMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src3511244156/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeyxQmLBTzu5ChnUZ051RifWhMT4WuFCZrevlz2OD_x3UMeta || {},
    component: () => import("/codebuild/output/src3511244156/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexBLnss_DuIfBu4dKlJ4bDNBI9kcK90nBY9pnIdJAAlNYMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3511244156/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeLqTTDYMqBlK3GUIaJ1018rS7Th7mJcszEBR9qMU3ODQMeta || {},
    component: () => import("/codebuild/output/src3511244156/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3511244156/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleSWSNWWRR9omaZjChALQxfLXnKwdZSTKO08W2FD_fRVAMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3511244156/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailLw1uu3C6kGSFqOVm4Eb5DeohSj5G6iR_9Ub1IpoDSV0Meta || {},
    component: () => import("/codebuild/output/src3511244156/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmDoWjdpR92_45ZzPWRcA29ZYkFRdVrzztd_94BnT001mw4Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3511244156/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentd_aZWtKUulu56LVSB9MQxJ0cFZ80D1iWQLKHDNDE8O4Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3511244156/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmAMO3_45m9c6CJvTKZoLT0H7chSwmtEWYYyo5_45twvtEA_UMeta || {},
    component: () => import("/codebuild/output/src3511244156/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeK_45yBlTgfQGxspT0LjgirdWJTH5YdGFAxTjV8jtNSOa0Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3511244156/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codepYNGOxX4oxBS5OE0Eyg9W3zKH2rTBijaEUOMJZJ2qhoMeta || {},
    component: () => import("/codebuild/output/src3511244156/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordUCx29S5RmDyGxFjNb4gSsYfY8y9uOJCP4P3epB3BTCIMeta || {},
    component: () => import("/codebuild/output/src3511244156/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3511244156/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register8kxN0Rg_XTy2SYHkWutsEyydOYkss7Ru4uqrS8eEJO4Meta || {},
    component: () => import("/codebuild/output/src3511244156/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeNWqLGjO_dKdF_6gbJtzwUuLRLHsGWKf4S_45CdODVIloIMeta || {},
    component: () => import("/codebuild/output/src3511244156/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src3511244156/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]